import React from 'react';
import { Worker, Viewer } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import './TradeLicense.css'; // Ensure you add the styles here

const TradeLicense = () => {
  return (
    <div className="pdf-viewer-container">
      <Worker workerUrl={`https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js`}>
        <Viewer fileUrl="/pdf/tradelicense.pdf" />
      </Worker>
    </div>
  );
}

export default TradeLicense;
